import { render, staticRenderFns } from "./submitprice.vue?vue&type=template&id=cc6ff1c2"
import script from "./submitprice.vue?vue&type=script&lang=js"
export * from "./submitprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports